<template>
  <div id="login">
    <section>
      <div class="col2" :class="{'signup-form': !showLoginForm && !showForgotPassword}">
        <transition name="slide-x-transition">
          <v-flex xs10 offset-xs1 sm6 offset-sm3 md4 offset-md4>
            <v-card v-if="showLoginForm" flat class="transparent my-5">
              <h1 class="text-xs-center white--text display-1 font-weight-bold my-4 mb-5">Welcome to Routine</h1>
<div style="margin-top: 50px !important" class="mt-5">
  
              <v-text-field color="white" class="main--text" v-model.trim="loginForm.email" :rules="emailRules" label="E-mail"
                placeholder="your@email.com" clearable required >
              </v-text-field>

              <v-text-field color="white" v-model.trim="loginForm.password" label="Password" placeholder="password"
                :append-icon="loginForm.showPassword ? 'mdi-eye-off' : 'mdi-eye' "
                :rules="[rules.required, rules.min]" :type="loginForm.showPassword ? 'text' : 'password'"
                class="input-group--focused my-5 main--text" outline text
                @click:append="loginForm.showPassword = !loginForm.showPassword" clearable required
                >
                </v-text-field>

              <v-layout align-center justify-center column>
                <login-btn class="swipe-button mb-2" textColor="#000" overlayColor="#FFBD2E"
                  @actionConfirmed="loginUserIn" />
             <span class="white--text body-2">{{errorMsg}}</span>
              </v-layout>

              <v-layout class="my-5" align-center justify-center wrap>
               
                <div class="google-btn shadow_y" @click="signUpGoogle">
                  <div class="google-icon-wrapper">
                    <img class="google-icon-svg" :src="googleLogo">
                  </div>
                  <p class="btn-text">
                    <b>Sign in with Google</b>
                  </p>
                </div>

                <v-btn class="white mt-2" width="184px" height="42px" @click="toggleForm">
                  NEW ACCOUNT?
                </v-btn>
            
              </v-layout>
             </div>
            </v-card>
          </v-flex>
        </transition>

         <!-- Sign up -->
        <transition name="slide-x-transition">
          <v-flex v-if="createAcc" xs10 offset-xs1 sm4 offset-sm4 md2 offset-md5>
            <h1 class="text-xs-center display-1 white--text font-weight-bold my-5">Create new Account</h1>
            <v-text-field
              v-model.trim="signupForm.name"
              label="Name"
              placeholder="your name"
              outline
              class="my-4 main--text"
              clearable
              required
              flat
              color="white"
              :hint="signupForm.hint"
            ></v-text-field>
            <v-text-field
              v-model.trim="signupForm.email"
              :rules="emailRules"
              label="E-mail"
              placeholder="your@email.com"
              outline
              clearable
              flat
              required
              class="my-4 main--text"
              color="white"
            ></v-text-field>

            <v-text-field
              v-model.trim="signupForm.password"
              label="Password"
              placeholder="password"
              :append-icon="signupForm.showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              :rules="[rules.required, rules.min]"
              :type="signupForm.showPassword ? 'text' : 'password'"
              value="peep13"
              class="input-group--focused my-4 main--text"
              outline
              @click:append="signupForm.showPassword = !signupForm.showPassword"
              clearable
              required
              flat
              color="white"
            ></v-text-field>
            <v-layout align-center justify-space-around column fill-height>

                <div style="display: flex; justify-content: center" class="google-btn main shadow_y" @click="signUp">
                  <p class="mt-2">
                    <b>Sign up</b>
                  </p>
                </div>

               <div class="google-btn shadow_y mt-3" @click="signUpGoogle">
                  <div class="google-icon-wrapper">
                    <img class="google-icon-svg" :src="googleLogo">
                  </div>
                  <p class="btn-text">
                    <b>Sign up with Google</b>
                  </p>
                </div>

                  <v-btn class="white--text mt-5" @click="toggleForm">
                    <span class="black--text">BACK</span>
                  </v-btn>
            </v-layout>
          </v-flex>

        
        </transition>

       
      </div>
    </section>
  </div>
</template>

<script>
    import lButton from "@/components/button";
    import loginBtn from "@/components/slider";
    import {
        mapGetters
    } from "vuex";
    import firebase from "firebase/app";
    import {
        auth,
        database
    } from "@/firebase/async-firestore";
import { setTimeout } from 'timers';

    export default {
        name: "login",
        components: {
            lButton,
            loginBtn
        },
        data() {
            return {
                oyenLinkedIn: 'https://www.linkedin.com/in/joergoyen/',
                oyen: 'https://routine.oyen.de',
                oyenLink: 'https://oyen.de/dev/routine/',
                lukas: 'https://www.linkedin.com/in/lukas-kreutzer/',
                googleLogo: require("@/assets/googleLogo.svg"),
                loginForm: {
                    email: "",
                    password: "",
                    showPassword: false
                },
                signupForm: {
                    name: "",
                    email: "",
                    password: "",
                    showPassword: false,
                    hint: "your special user name"
                },
                passwordForm: {
                    email: ""
                },
                showLoginForm: true,
                createAcc: false,
                showForgotPassword: false,
                passwordResetSuccess: false,
                performingRequest: false,
                name: null,
                styling: 'create-btn',
                textStyle: 'create-t-btn',
                 errorMsg: "",
                emailRules: [
                  v => !!v || "E-mail is required",
                  v => /.+@.+/.test(v) || "E-mail must be valid"
                ],
                rules: {
                  required: value => !!value || "Required.",
                  min: v => v.length >= 6 || "Min 6 characters",
                  emailMatch: () => "The email and password you entered don't match",
                  password: v =>
                    (v || "").match(
                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/
                    ) ||
                    "Password must contain an upper case letter, a numeric character, and a special character"
                },
            };
        },
        computed: {
            ...mapGetters("user", ["isUserLoggedIn"])
        },
        methods: {
            toggleForm() {
                this.errorMsg = "";
                this.showLoginForm = !this.showLoginForm;
                this.createAcc = !this.createAcc;
            },
            togglePasswordReset() {
                if (this.showForgotPassword) {
                    this.showLoginForm = true;
                    this.showForgotPassword = false;
                    this.passwordResetSuccess = false;
                } else {
                    this.showLoginForm = false;
                    this.showForgotPassword = true;
                }
            },
            async loginUserIn() {
                this.performingRequest = true;
                (await auth())
                .signInWithEmailAndPassword(
                        this.loginForm.email,
                        this.loginForm.password
                    )
                    .then(userCredential => {
                        this.performingRequest = false;
                         this.$router.push({
                            name: 'home'
                        })
                    })
                    .catch(err => {
                        console.log(err);
                        this.performingRequest = false;
                        this.errorMsg = err.message;
                    });
            },
            async updateProfile() {
                this.performingRequest = true;
                try {
                    (await auth()).currentUser.updateProfile({
                        displayName: this.signupForm.name,
                        photoURL: this.avatar
                    });
                } catch (err) {
                    console.log(err);
                }
            },
            async signUp() {
                if (
                    this.signupForm.name !== "" &&
                    this.signupForm.email !== "" &&
                    this.signupForm.password
                ) {
                    (await auth())
                    .createUserWithEmailAndPassword(
                            this.signupForm.email,
                            this.signupForm.password
                        )
                        .then(() => {
                            this.updateProfile();
                        })
                        .then(() => {
                          this.$router.push({
                            name: 'home'
                          })
                        })
                        .catch(err => {
                            console.log(err);
                        });
                    try {} catch (err) {
                        console.log(err);
                    }
                }
            },
            async signUpGoogle() {
                const provider = new firebase.auth.GoogleAuthProvider();
                try {
                    (await auth()).signInWithRedirect(provider).then(() => {
                        this.updateProfile();
                    })
                      this.$router.push({
                            name: 'home'
                          })
                    
                } catch (err) {
                    console.log(err);
                }
            },
            async resetPassword() {
                this.performingRequest = true;
                try {
                    (await auth())
                    .sendPasswordResetEmail(this.passwordForm.email)
                        .then(() => {
                            this.performingRequest = false;
                            this.passwordResetSuccess = true;
                            this.passwordForm.email = "";
                        })
                        .catch(err => {
                            console.log(err);
                            this.performingRequest = false;
                            this.errorMsg = err.message;
                        });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    };
</script>

<style>
#login .theme--light.v-input:not(.v-input--is-disabled) input,
#login .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: #fff !important;
}


#login .theme--light.v-label {
    color: #fff !important;
    font-size: 17px;
}

#login .theme--light.v-text-field>.v-input__control>.v-input__slot:before {
    border-color: #fff !important;
}

#login .theme--light.v-icon {
    color: #FFBD2E;
}

#login .theme--light.v-text-field>.v-input__control>.v-input__slot:before {
    border-color: #FFBD2E !important;
}


    p {
        display: inline-block;
    }
  .swipe-button {
  width: 60%;
}
.google-btn {
  margin: 11px;
  width: 80%;
  min-width: 184px;
  max-width: 184px;
  height: 42px;
  background: #fff;
  border-radius: 2px;
  cursor: pointer;
  cursor: hand;
  align-self: center;
  user-select: none;
  line-height: 1.62;
  transition: all 400ms ease 0s;
  display: flex;
}
.google-btn .google-icon-wrapper {
  position: absolute;
  margin-top: 1.8px;
  margin-left: 1px;
  width: 40px;
  height: 40px;
  border-radius: 2px;
  user-select: none;
}
.google-btn .google-icon-svg {
  position: absolute;
  margin-top: 8px;
  margin-left: 8px;
  margin-right: 14px;
  width: 22px;
  height: 22px;
  user-select: none;
}
.google-btn .btn-text {
  margin: 11px 14px 40px 40px;
  color: #757575;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: Roboto;
  font-weight: medium;
  user-select: none;
}
.google-btn:hover {
  box-shadow: 0 3px 8px rgba(117, 117, 117, 0.5);
  user-select: none;
}
.google-btn:active {
  box-shadow: 0 1px 1px #757575;
  background: #f8f8f8;
  color: #fff;
  user-select: none;
}
</style>